<div class="dx-card wide-card">
<h4 class="content-block ap-green">Contract List</h4>



<dx-data-grid id="gridContainer"
            [dataSource]="filteredContractsList"
            keyExpr="contractId"
            [allowColumnReordering]="true"
            [showRowLines]="true"
            [showColumnLines]="true"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [rowAlternationEnabled]="true"
            [columnHidingEnabled]="false"
            [allowColumnResizing]="true"
            (onRowDblClick)="onRowDoubleClick($event)"
            (onRowUpdating)="onSaving($event)">


  <dxo-filter-row [visible]="showFilterRow"
                  [applyFilter]="currentFilter"></dxo-filter-row>
  <dxo-header-filter [visible]="showHeaderFilter"></dxo-header-filter>
  <dxo-search-panel [visible]="true"></dxo-search-panel>
  <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
  <dxo-filter-panel [visible]="false"></dxo-filter-panel>
  <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
  <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
  <dxo-pager
    [visible]="true"
    [allowedPageSizes]="allowedPageSizes"
    [showPageSizeSelector]="true"
    [showInfo]="true"
    [showNavigationButtons]="false"
  >
  </dxo-pager>
  <dxo-toolbar>
    <!-- <dxi-item name="addRowButton" showText="always" [options]="{ text: 'Add Contract'  }"> </dxi-item> -->
    <dxi-item name="groupPanel"></dxi-item>
    <dxi-item location="after">
      <dx-button text="Add Contract" type="default" [routerLink]="['/add-contract']"></dx-button>
        <dx-button text="Reset" type="default" (onClick)="resetFilters()">
      </dx-button>
      <dx-button icon="exportxlsx" text="Export to Excel" type="default" (onClick)="exportExcel($event)">
      </dx-button>
    </dxi-item>
    <dxi-item name="searchPanel"></dxi-item>
  </dxo-toolbar>
  <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
  <dxo-editing mode="row"
               [allowUpdating]="true"
               [allowAdding]="true"
               [useIcons]="true"
               [(editRowKey)]="editRowKey">
  </dxo-editing>

  <dxi-column type="buttons" [width]="75" fixed="true" fixedPosition="left" >
      <dxi-button name="edit"></dxi-button>
  </dxi-column>

  <dxi-column dataField="customer" [allowEditing]="false" [fixed]="true" caption="Customer" [width]="225" headerCellTemplate="boldHeaderTemplate">
    
  </dxi-column>
  <dxi-column dataField="supplier" caption="Supplier" [width]="225" [fixed]="true" headerCellTemplate="titleHeaderTemplate">
    <dxi-validation-rule type="required"></dxi-validation-rule>
    <dxo-lookup [dataSource]="suppliers" displayExpr="supplierName" valueExpr="supplierName">
    </dxo-lookup>
  </dxi-column>
  <dxi-column dataField="materialId" caption="Material" [width]="125" headerCellTemplate="titleHeaderTemplate">
    <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxo-lookup [dataSource]="materials" displayExpr="materialName" valueExpr="materialId">
      </dxo-lookup>
  </dxi-column>
  <div *dxTemplate="let info of 'titleHeaderTemplate'">
    <b>{{info.column.caption}}&#42;</b>
  </div>
  <dxi-column dataField="quantity" caption="Qty" headerCellTemplate="boldHeaderTemplate">
  </dxi-column>
  <dxi-column dataField="quantityUom" caption="Qty UOM" headerCellTemplate="boldHeaderTemplate"></dxi-column>
  <div *dxTemplate="let info of 'boldHeaderTemplate'">
    <b>{{info.column.caption}}</b>
  </div>
  <dxi-column dataField="price" dataType="string" headerCellTemplate="boldHeaderTemplate" caption="Price"></dxi-column>
  <dxi-column dataField="pricingUom" caption="Pricing UOM" headerCellTemplate="boldHeaderTemplate"></dxi-column>
  <dxi-column dataField="supplyMode" caption="Supply Mode" headerCellTemplate="boldHeaderTemplate" [width]="125">
      <dxo-lookup [dataSource]="supplyModes" displayExpr="" valueExpr="">
      </dxo-lookup>
  </dxi-column>

  <dxi-column dataField="awardYear" dataType="string" caption="Award Year" headerCellTemplate="boldHeaderTemplate">
      <dxo-lookup [dataSource]="awardYears" displayExpr="" valueExpr="">
      </dxo-lookup>
  </dxi-column>

  <dxi-column dataField="term" dataType="string" caption="Term" headerCellTemplate="boldHeaderTemplate"></dxi-column>
  <dxi-column dataField="commenceYear" caption="Commence Year" headerCellTemplate="boldHeaderTemplate">
      <dxo-lookup [dataSource]="awardYears" displayExpr="" valueExpr="">
      </dxo-lookup>
  </dxi-column>

  <dxi-column dataField="expireYear" caption="Expire Year" headerCellTemplate="boldHeaderTemplate">
      <dxo-lookup [dataSource]="awardYears" displayExpr="" valueExpr="">
      </dxo-lookup>
  </dxi-column>

  <dxi-column dataField="annualRevenue" dataType="string" caption="Annual Contract Revenues" headerCellTemplate="boldHeaderTemplate"></dxi-column>
  <dxi-column dataField="notes"></dxi-column>  
</dx-data-grid>

<dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="true" [closeOnOutsideClick]="false">
    </dx-load-panel>
  </div>